import React, { useState } from "react";
import Footer from "../Footer/Footer";
import Nav from "../Nav";
import Navbar from "../Navbar";
import County from "./County";
import Disability from "./Disability";
import PhoneNo from "./PhoneNo";
import { useNavigate } from "react-router-dom";

export default function RegistrationForm() {
  const navigate = useNavigate();

  // State to handle County not Selected
  const [county, setCounty] = useState("");
  const [countyError, setCountyError] = useState("");

  //State to handle Gender not Selected
  const [gender, setGender] = useState("");
  const [genderError, setGenderError] = useState("");

  // State to handle title not selected
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState("");

  //State to handle incorrect surname
  const [surname, setSurname] = useState("");
  const [surnameError, setSurnameError] = useState("");

  //State to handle incorrect Country
  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState("");

  //State to handle incorrect othernames
  const [othernames, setOthernames] = useState("");
  const [othernamesError, setOthernamesError] = useState("");

  //State to handle incorrect email address
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  //State to handle disability
  const [disability, setDisability] = useState("");
  const [disabilityError, setDisabilityError] = useState("");

  // State to handle Role in the organization is not Selected
  const [role, setRole] = useState("");
  const [roleError, setRoleError] = useState("");

  const registrationData = {
    surname,
    country,
    title,
    role,
    email,
  };
  localStorage.setItem("registrationData", JSON.stringify(registrationData));

  //If surname is not a string
  const handleSurnameChange = (event) => {
    const value = event.target.value;
    setSurname(value);
    localStorage.setItem("surname", value);
    if (isNaN(value)) {
      setSurnameError("");
    } else {
      setSurnameError("Please enter a valid surname");
    }
  };

  //If Country is not a string
  const handleCountryChange = (event) => {
    const value = event.target.value;
    setCountry(value);
    localStorage.setItem("country", value);
    if (isNaN(value)) {
      setCountryError("");
    } else {
      setCountryError("please enter a valid Country");
    }
  };

  //If Gender is not Selected
  const handleGenderChange = (event) => {
    const selectedGender = event.target.value;
    setGender(selectedGender);
    localStorage.setItem("selectedgender", selectedGender);
    if (selectedGender === "") {
      setGenderError("Please provide your Gender");
    } else {
      setGender(selectedGender);
      setGenderError("");
    }
  };

  //If Title is not selected
  const handleTitleChange = (event) => {
    const selectedTitle = event.target.value;
    localStorage.setItem("title", selectedTitle);

    if (selectedTitle === "") {
      setTitleError("Please select a title");
    } else {
      setTitle(selectedTitle);
      setTitleError("");
    }
  };

  // If County is not selected
  const handleCountyChange = (event) => {
    const selectedCounty = event.target.value;
    localStorage.setItem("county", selectedCounty);
    if (selectedCounty === "") {
      setCountyError("Please select a your County");
    } else {
      setCounty(selectedCounty);
      setCountyError("");
    }
  };

  //If othernames is not a string
  const handleOthernamesChange = (event) => {
    const value = event.target.value;
    setOthernames(value);
    localStorage.setItem("othernames", value);
    if (isNaN(value)) {
      setOthernamesError("");
    } else {
      setOthernamesError("Please enter valid names");
    }
  };

  //If email address is not in the correct format
  const handleEmailChange = (event) => {
    const value = event.target.value;
    setEmail(value);
    localStorage.setItem("email", value);
    if (!value.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  //If disability is not a string
  const handleDisabilityChange = (event) => {
    const value = event.target.value;
    setDisability(value);
    localStorage.setItem("disability", value);
    if (isNaN(value)) {
      setDisabilityError("");
    } else {
      setDisabilityError("Please enter a valid disability");
    }
  };

  // If Role in the Conference is not Selected
  const handleRoleChange = (event) => {
    const selectedRole = event.target.value;
    setRole(selectedRole);
    localStorage.setItem("selectedrole", selectedRole);
    if (selectedRole === "") {
      setGenderError("Please select your role in the conference");
    } else {
      setRole(selectedRole);
      setRoleError("");
    }
  };

  // Define a function to reset the form fields
  const handleReset = () => {
    setSurname("");
    setSurnameError("");
    setOthernames("");
    setOthernamesError("");
    setEmail("");
    setEmailError("");
    setDisability("");
    setDisabilityError("");
    setTitle("");
    setTitleError("");
    setCounty("");
    setCountyError("");
    setGender("");
    setGenderError("");
    setCountry("");
    setCountryError("");
    setRole("");
    setRoleError("");
  };

  return (
    <div>
      <Nav />
      <Navbar />
      <div
        className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-100"
        style={{ marginTop: "0px" }}
      >
        <div>
          <a href="/">
            <h3
              style={{ marginTop: "20px" }}
              className="text-4xl font-bold text-indigo-900"
            >
              Personal Details
            </h3>
          </a>
        </div>
        <div className="w-full px-6 py-4 mt-6 overflow-hidden bg-white  sm:max-w-xl md:max-w-2xl lg:max-w-3xl rounded-md shadow-md">
          <form>
            <div className="mt-4">
              <label
                htmlFor="email"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-t-[8px]"
              >
                Email<span className="text-red-500 italic">*</span>
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="email"
                  name="email"
                  autoComplete="none"
                  placeholder="Enter Your email address"
                  className="block w-full mt-1 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 h-15 px-4 py-3 border-2 border-gray-400 rounded-[8px]"
                  value={email}
                  onChange={handleEmailChange}
                />
                {emailError && (
                  <span className="text-red-500 italic ">{emailError}</span>
                )}
              </div>
            </div>

            <div className="mt-4">
              <label
                htmlFor="title"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-t-[8px]"
              >
                Title<span className="text-red-500 italic">*</span>
              </label>
              <div className="relative inline-block w-full">
                <select
                  className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  onChange={handleTitleChange}
                  value={title}
                >
                  <option value="">Select a title...</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Ms.">Ms.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Rev.">Rev</option>
                  <option value="Bishop.">Bishop.</option>
                  <option value="Dr.">Dr.</option>
                  <option value="Prof.">Prof.</option>
                  <option value="Hon.">Hon.</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mb-4">
                  <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M6.293 6.707a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              {titleError && (
                <span className="text-red-500 italic ">{titleError}</span>
              )}
            </div>

            <div>
              <label
                htmlFor="surname"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 mt-7 rounded-t-[8px]"
              >
                Surname<span className="text-red-500 italic">*</span>
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="surname"
                  autoComplete="none"
                  placeholder="Enter your Surname"
                  className="block w-full mt-1   shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 h-15 px-4 py-2 border-2 border-gray-400 rounded-[8px]"
                  onChange={handleSurnameChange}
                  value={surname}
                />
                {surnameError && (
                  <span className="text-red-500 italic">{surnameError}</span>
                )}
              </div>
            </div>

            <div>
              <label
                htmlFor="othernames"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-t-[8px] mt-7"
              >
                Other Names<span className="text-red-500 italic">*</span>
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="othernames"
                  autoComplete="none"
                  placeholder="Enter your other names"
                  className="block w-full mt-1 rounded-[8px] shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 h-15 px-4 py-2 border-2 border-gray-400"
                  onChange={handleOthernamesChange}
                  value={othernames}
                />
                {othernamesError && (
                  <span className="text-red-500 italic">{othernamesError}</span>
                )}
              </div>
            </div>

            <div className="mt-4">
              <label
                htmlFor="country"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-[8px] mt-7"
              >
                Country Of Nationality
                <span className="text-red-500 italic">*</span>
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="country"
                  autoComplete="none"
                  placeholder="Enter Your Country of Nationality"
                  className="block w-full mt-1  rounded-[8px] shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 h-15 px-4 py-2 border-2 border-gray-400"
                  onChange={handleCountryChange}
                  value={country}
                />
                {countryError && (
                  <span className="text-red-500 italic ">{countryError}</span>
                )}
              </div>
            </div>
            <div className="mt-4">
              <label
                htmlFor="county"
                className="block teblock bg-green-100 py-2 px-3 rounded-t-[8px] mt-7xt-sm font-medium text-gray-700 undefined"
              >
                County
              </label>
              <div className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <County onChange={handleCountyChange} value={county} />
              </div>
              {countyError && (
                <span className="text-red-500 italic">{countyError}</span>
              )}
            </div>

            <div className="mt-4">
              <label
                htmlFor="gender"
                className="block font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-md"
              >
                Gender<span className="text-red-500 italic">*</span>
              </label>
              <div className="relative inline-block w-full">
                <select
                  className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  onChange={handleGenderChange}
                  value={gender}
                >
                  <option value="">--Select Gender--</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M6.293 6.707a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              {genderError && (
                <span className="text-red-500 italic">{genderError}</span>
              )}
            </div>

            <div>
              <label
                htmlFor="phoneno"
                autoSave="none"
                autoComplete="false"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-md mt-7"
              >
                PhoneNo<span className="text-red-500 italic">*</span>
              </label>
              <div className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <PhoneNo />
              </div>
            </div>

            <div>
              <label
                htmlFor="disability"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-md mt-7"
              >
                Disability<span className="text-red-500 italic">*</span>
              </label>
              <div className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <Disability
                  onChange={handleDisabilityChange}
                  value={disability}
                />
              </div>
              {disabilityError && (
                <span className="text-red-500 italic">{disabilityError}</span>
              )}
            </div>

            <div className="mt-4">
              <label
                htmlFor="role"
                className="block  font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-md"
              >
                Role in the Conference
                <span className="text-red-500 italic">*</span>
              </label>
              <div className="relative inline-block w-full">
                <select
                  className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  onChange={handleRoleChange}
                  value={role}
                >
                  <option value="">--Select--</option>
                  <option value="Delegate for Main Conference">
                    Delegate for Main Conference
                  </option>
                  <option value=" Delegate for youth event">
                    Delegate for youth event{" "}
                  </option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M6.293 6.707a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              {roleError && <p className="text-red-500 italic">{roleError}</p>}
            </div>

            <button
              className=" text-blue-700 hover:underline"
              type="reset"
              onClick={handleReset}
            >
              Reset?
            </button>
            <div className="flex flex-col items-center mt-4">
              <button
                onClick={() => {
                  if (
                    surname === "" ||
                    othernames === "" ||
                    email === "" ||
                    emailError !== "" ||
                    disabilityError !== "" ||
                    gender === "" ||
                    genderError !== "" ||
                    country === "" ||
                    countryError !== "" ||
                    title === "" ||
                    titleError !== "" ||
                    role === "" ||
                    roleError !== ""
                  ) {
                    alert("Please fill all required fields");
                  } else {
                    navigate("/professional");
                  }
                }}
                className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-indigo-900 rounded-md hover:bg-green-500 focus:outline-none focus:bg-purple-600"
              >
                Next
              </button>
              <div>
                {surname === "" ||
                othernames === "" ||
                email === "" ||
                emailError !== "" ||
                disabilityError !== "" ||
                gender === "" ||
                genderError !== "" ||
                country === "" ||
                countryError !== "" ||
                title === "" ||
                titleError !== "" ||
                role === "" ||
                roleError !== "" ? (
                  <span className="text-red-500 italic  mt-2">
                    Please fill all required fields *
                  </span>
                ) : null}
              </div>
            </div>
          </form>
          <div className="mt-4 text-grey-600">
            Already Registered?{" "}
            <span>
              <a
                onClick={() => navigate("/")}
                className="text-blue-700 hover:underline "
                href="/"
              >
                Home
              </a>
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2">
        <Footer />
      </div>
    </div>
  );
}
